/**
 * @file TOPスライダー
 *
 */
'use strict';
import Swiper from 'swiper/bundle';

/**
 * @classname Slider
 * @classdesc TOPスライダー
 */
export default class Slider {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('Slider.constructor');
		this._$e = $e[0];
		const optionId = $e.attr('data-option');
		const option = this.getOption(optionId);
		console.log(option);
		this._swiper = new Swiper(this._$e, option);
		console.log(this._swiper);
	};


	/**
	 * オプション設定
	 *
	 * @memberof Slider
	 * @param optionId {string} - オプションID
	 * @return option {array} - オプション
	 */
	getOption(optionId) {
		console.log('Slider.getOption');
		let option = {};
		switch(optionId) {
			case '1':
				option = {
					loop: true,
					autoplay: true,
					delay: 5000,
					pagination: {
						el: '.swiper-pagination',
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
				}
				break;
			case '2':
				option = {
					slidesPerView: 'auto',
					freeMode: true,
					spaceBetween: 0
				}
				break;
			case '3':
				option = {
					slidesPerView: '1',
					spaceBetween: 0,
					pagination: {
						el: '.swiper-pagination',
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					}
				}
				break;
		}
		return option;
	};
}
